import { useMemo } from 'react'
import { MermaidDiagram } from './Mermaid'
import { FRAME_SANDBOX, frameDoc, type Canvas } from '@/lib/panel'

/**
 * What Prime put on the canvas. Mermaid is drawn by the app's own (strict,
 * sanitised) renderer. An SVG or a mock-up is untrusted markup from a model, so
 * it is shown in an iframe with an empty sandbox: an opaque origin (no
 * cookies, storage or access to the app or its API), no scripts, no forms, no
 * popups, no referrer, and a CSP inside the document that allows nothing but
 * inline styles and data: images. See docs/security.md, "The canvas frame".
 */
export const CanvasView = ({ canvas }: { canvas: Canvas }) => {
  const doc = useMemo(
    () => (canvas.kind === 'mermaid' ? '' : frameDoc(canvas.kind, canvas.content)),
    [canvas.kind, canvas.content],
  )
  if (canvas.kind === 'mermaid') return <MermaidDiagram source={canvas.content} className="p-3" />
  return (
    <iframe
      title={canvas.title || 'Canvas'}
      sandbox={FRAME_SANDBOX}
      srcDoc={doc}
      referrerPolicy="no-referrer"
      allow=""
      className="w-full h-full min-h-[320px] bg-white rounded-[var(--radius-card-inner)] border border-line"
      data-testid="canvas-frame"
    />
  )
}
